import { useTranslation } from 'react-i18next'

import { ComboBox, RadioGroup } from '@reveni-io/reveni-ui'

import ScenarioCard from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/PreviewSettingsSidebar/CustomScenarioSettings/ScenarioCard/ScenarioCard'

import { scenarioShipmentTypeOptions, statusFieldLabelsByShipmentType } from './constants'
import { getShipmentStatusOptions, getShipmentTypeChanges } from './helpers'

const ScenarioShipmentCard = ({ shipment, position, onChange, onRemove }) => {
  const { t } = useTranslation()

  const typeOptions = scenarioShipmentTypeOptions.map(option => ({ value: option.value, label: t(option.label) }))
  const statusOptions = getShipmentStatusOptions(shipment.type, t)

  const handleChangeType = event => onChange(shipment.id, getShipmentTypeChanges(shipment, event.target.value))

  const handleChangeStatus = event => onChange(shipment.id, { status: event.target.value })

  const handleRemove = () => onRemove(shipment.id)

  return (
    <ScenarioCard
      title={t('Envío #{{number}}', { number: position })}
      removeLabel={t('Eliminar envío #{{number}}', { number: position })}
      testId={`scenario-shipment-${position}`}
      onRemove={handleRemove}
    >
      <RadioGroup
        label={t('Tipo de envío')}
        name={`scenario-shipment-${shipment.id}-type`}
        options={typeOptions}
        value={shipment.type}
        orientation="row"
        onChange={handleChangeType}
      />
      <ComboBox
        fullWidth
        label={t(statusFieldLabelsByShipmentType[shipment.type], { number: position })}
        menuItems={statusOptions}
        value={shipment.status}
        handleChange={handleChangeStatus}
      />
    </ScenarioCard>
  )
}

export default ScenarioShipmentCard
